module.exports = __webpack_public_path__ + "static/media/indirizzi2.37b9f7eb.png";